function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M449.5,51.2c-10,0-124.3,5.2-193.5,45.5C186.8,56.4,72.4,51.2,62.5,51.2C28,51.2,0,78.7,0,112.4v251 c0,32.6,26,59.4,59.1,61.1c29.4,1.5,103,7.6,150.2,31c6.6,3.2,13.8,5,21.1,5.3v0h51.2v0c7.3-0.2,14.5-2,21.1-5.3 c47.1-23.4,120.8-29.4,150.2-31C486,422.9,512,396,512,363.4v-251C512,78.7,484,51.2,449.5,51.2z M236.8,401.7 c0,8.9-8.8,15.1-17.1,12C168.1,394.1,96.6,388,61.1,386.2c-12.7-0.6-22.7-10.6-22.7-22.8v-251c0-12.6,10.8-22.8,24-22.8 c15.9,0.1,101.2,6.2,158.8,32.4c9.3,4.2,15.4,13.3,15.4,23.6l0.1,84.9V401.7z M473.6,363.4c0,12.1-10,22.1-22.7,22.8 c-35.5,1.8-107,7.9-158.6,27.5c-8.3,3.2-17.1-3.1-17.1-12V230.4l0.1-84.9c0-10.2,6.1-19.3,15.4-23.6 c57.6-26.1,142.9-32.3,158.8-32.4c13.2,0,24,10.2,24,22.8V363.4L473.6,363.4z"
});

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.61c29428.svg";
export { ForwardRef as ReactComponent };